import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = ["subCategorySelect"]
	static values = { url: String }

	async loadSubCategories(event) {
		const categoryId = event.target.value
		const subCategorySelect = this.subCategorySelectTarget

		if (!categoryId) {
			subCategorySelect.innerHTML = '<option value="">Sélectionner une sous-catégorie</option>'
			return
		}

		try {
			const response = await fetch(`${this.urlValue}?category_id=${categoryId}`)
			const subCategories = await response.json()

			// Clear current options
			subCategorySelect.innerHTML = '<option value="">Sélectionner une sous-catégorie</option>'

			// Add new options
			subCategories.forEach(subCategory => {
				const option = document.createElement('option')
				option.value = subCategory.value
				option.textContent = subCategory.label
				subCategorySelect.appendChild(option)
			})
		} catch (error) {
			console.error('Error loading sub-categories:', error)
		}
	}
}
